import { FC, PropsWithChildren } from "react";
import { useRecoilValue } from "recoil";

import { useRtl } from "@ryde/redux";
import {
  drawersAtom,
  resolveOffsetWidthMultipleDrawers,
  RIGHTBAR_DEFAULT_WIDTH,
  RIGHTBAR_DEFAULT_WIDTH_MOBILE,
  useIsMobile,
} from "@ryde/shared";

import {
  drawerMotionAnimationVariants,
  menuDrawerMotionAnimationVariants,
} from "./drawerMotionAnimationVariants";
import { DrawerMotionMenuWrapperStyled } from "./menu-wrapper.styled";

interface IMenuDrawerWrapperProps extends PropsWithChildren {
  dataE2EName?: string;
  customWidth?: string;
  drawerNumber?: number;
}

export const MenuDrawerWrapper: FC<IMenuDrawerWrapperProps> = ({
  dataE2EName,
  customWidth = RIGHTBAR_DEFAULT_WIDTH,
  drawerNumber,
  children,
}) => {
  const { isRtl } = useRtl();
  const { isMobile } = useIsMobile();
  const drawers = useRecoilValue(drawersAtom);

  customWidth =
    drawerNumber !== undefined
      ? resolveOffsetWidthMultipleDrawers({
          customWidth,
          drawersNumber: drawers.length - 1 - drawerNumber,
        }) + "px"
      : customWidth;

  return (
    <DrawerMotionMenuWrapperStyled
      custom={isMobile ? RIGHTBAR_DEFAULT_WIDTH_MOBILE : customWidth}
      variants={
        isMobile
          ? drawerMotionAnimationVariants({ isRtl })
          : menuDrawerMotionAnimationVariants(isRtl)
      }
      animate="animation"
      initial="initial"
      exit="exit"
      data-e2e-name={dataE2EName}
    >
      {children}
    </DrawerMotionMenuWrapperStyled>
  );
};
